import BaseChannel from './BaseChannel';
import Sequence from './Sequence';
import * as Instruments from "./instruments/all";

class SequenceChannel extends BaseChannel {

	constructor(number) {
		var sequence;
		var path = "CHANNEL_" + number;
		super(path);
		this.sequences = [];
		for (var i = 0; i < 12; i++) {
			sequence = new Sequence(number, i);
			sequence.on("SEQUENCE_QUEUED", this.handleSequenceQueued.bind(this));
			sequence.on("SEQUENCE_PLAYING", this.handleSequencePlaying.bind(this));
			sequence.on("SEQUENCE_FINISHED", this.handleSequenceFinish.bind(this));
			this.sequences.push(sequence);
		}
		this.name = "Channel " + (number+1);

		this.number = number;

		this.playingSequence = false;
		this.queuedSequence = false;

		this.instrument = new Instruments.SquareWaveSynth(this.path + "_INSTRUMENT");
	}

	handleSequenceQueued(payload) {
		this.queuedSequence = payload.sequence;
		this.emit("SEQUENCE_QUEUED", payload);
	}
	handleSequencePlaying(payload) {
		this.playingSequence = payload.sequence;
		this.queuedSequence = false;

		setImmediate(() => {
			this.emit("SEQUENCE_PLAYING", payload);
		});
	}

	handleSequenceFinish() {
		if(this.queuedSequence === false) return;

		if(this.queuedSequence !== -1) {
			if(this.sequences[this.queuedSequence].empty) {
				this.sequences[this.queuedSequence].unqueue();
				this.queuedSequence = false;
				setImmediate(() => {
					this.emit("REFRESH_SEQUENCES", {channel: this.number });
				});
			}
		} else {
			this.queuedSequence = false;
			setImmediate(() => {
				this.emit("REFRESH_SEQUENCES", {channel: this.number });
			});
		}

		this.sequences[this.playingSequence].stop();
		this.playingSequence = false;

	}

	assignInstrument(type) {
		if(Instruments[type] && this.instrument.type !== type) {
			this.instrument = new Instruments[type](this.path + "_INSTRUMENT");
			return true;
		}
		return false;
	}

	queueSequence(number) {
		if(this.queuedSequence !== false && this.sequences[this.queuedSequence]) {
			this.sequences[this.queuedSequence].unqueue();
		}

		if(number === this.playingSequence) {
			this.queuedSequence = false;
			this.emit("REFRESH_SEQUENCES", {channel: this.number });
			return true;
		}

		if(number === -1) {
			if(this.playingSequence !== false) {
				this.queuedSequence = -1;
				this.emit("REFRESH_SEQUENCES", {channel: this.number });
				return true;
			} else {
				return false;
			}
		}

		var s = this.sequences[number];

		if(s.empty && this.playingSequence === false) {
			this.queuedSequence = false;
			this.emit("REFRESH_SEQUENCES", {channel: this.number });
			return false;
		}

		s.queue();

		return true;
	}

	getPlayingSequence() {
		if(this.playingSequence === false) return false;
		return this.sequences[this.playingSequence];
	}

	getQueuedSequence() {
		if(this.queuedSequence === false) return false;
		return this.sequences[this.queuedSequence];
	}

	getNextSequence(beatNumber) {
		if(this.playingSequence === false) {
			if(this.queuedSequence !== false && beatNumber === 0) {
				var sequence = this.sequences[this.queuedSequence];
				if(sequence.empty) {
					sequence.unqueue();
					this.queuedSequence = false;
					setImmediate(() => {
						this.emit("REFRESH_SEQUENCES", {channel: this.number });
					});
					return false;
				}
				return sequence;
			}
			return false;
		}
		return this.sequences[this.playingSequence];
	}

	rehydrate(state) {
		super.rehydrate(state);
		for (var i = state.sequences.length - 1; i >= 0; i--) {
			this.sequences[i].rehydrate(state.sequences[i] || {})
		}
		if(state.instrument !== false) {
			if(Instruments[state.instrument.type]) {
				this.instrument = new Instruments[state.instrument.type](this.path + "_INSTRUMENT");
				this.instrument.rehydrate(state.instrument);
			}
		}
		this.playingSequence = false;
		this.queuedSequence = false;
	}

	dehydrate() {
		var state = super.dehydrate();
		state.sequences = this.sequences.map(function(sequence){
			return sequence.dehydrate();
		});
		state.instrument = (this.instrument === false ? false : this.instrument.dehydrate());
		return state;
	}
}

export default SequenceChannel;
